<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{modalDetails.title}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ng-content></ng-content>
            </div>
            <div class="modal-footer" *ngIf="footer == 'true'">
                <button type="button" class="btn _btn-primary" data-dismiss="modal" (click)="closeModal(false)">No</button>
                <button type="button" class="btn _btn-success" data-dismiss="modal" (click)="closeModal(true)">Yes</button>
            </div>
        </div>
    </div>
</div>